<template>
  <div id="about-page">
    <tab-header :key="$route.path" :id="3" :ex="0" :mode="true" />
    <div class="wrapper">
      <div class="contents">
        <!-- <div class="main-title">
          <h1>개발내용</h1>
          <p>
            자유로운 통합실험이 가능한 실험실습 공유플랫폼 V-Lab은 세 가지
            유형의 실험을 지원하도록 개발되었습니다.
          </p>
        </div> -->
        <div class="main-title" style="font-weight: bold; color: #193D8F;">
          <h2 style="font-size:20px;">자유로운 통합실험이 가능한 실험실습 공유플랫폼 V-Lab은 세 가지
            유형의 실험을 지원하도록 개발되었습니다.</h2>
        </div>
        <div class="details">
          <p>
            시나리오기반실험은 짜여진 실험요목을 순서대로 수행하며 한정된
            상황속에서 정해진 결과값을 얻는 과정에서 전자전기계측기와 부품들에
            대한 이해를 획득하는 과정이다.
          </p>
          <p>
            이에 반해 전기전자통합실험은 모든 장비 및 부품을 모듈화하여 자유로운
            실험이 가능하도록 만들어져 있으므로 활용도가 높은 반면, 초보자가
            실험에 대한 이해없이 사용하기는 다소 어려울 수 있다.
          </p>
          <p>
            아두이노통합실험은 전공자 뿐만 아니라 비전공자도 쉽게 쓸 수 있게
            만든 아두이노 보드와 프로그래밍을 웹상에서 바로 연결하고 코딩까지 해
            볼 수 있도록 구성되어 있다.
          </p>
        </div>
        <div class="box-content" style="">
          <div class="box-item">
            <div class="box-item-image box-item-image-1"></div>
            <div class="box-item-title">전기전자통합실험</div>
            <div>
              <p>
                전원공급기, 오실로스코프, 멀티미터, 함수발생기 등 주요 계측장비
                모듈화
              </p>

              <p>
                저항, 콘덴서, 인덕터, 다이오드, 트랜지스터, 아날로그 센서 등
                주요 부품 모듈화
              </p>

              <p>
                모듈 조합으로 다양한 주제의 실험을 자유롭게 구상하고 실행할 수
                있음.
              </p>
            </div>
          </div>
          <div class="box-item">
            <div class="box-item-image box-item-image-2"></div>
            <div class="box-item-title">아두이노통합실험</div>
            <div>
              <p>
                아두이노와 각종 전자부품 및 센서들과 디지털/아날로그 신호를
                주고받는 하드웨어 구현
              </p>
              <p>
                실제와 동일한 소스코드로 프로그래밍이 가능하여 자유로운 실험이
                가능
              </p>
            </div>
          </div>
          <div class="box-item">
            <div class="box-item-image box-item-image-3"></div>
            <div class="box-item-title">시나리오기반실험</div>
            <div>
              <p>
                부산대 기계공학부 교과목 전자전기기초실험 및 설계 실험 요목을
                시나리오 기반으로 개발
              </p>
              <p>
                ‘키르히호프의 법칙’, ‘옴의 법칙’ 등 다양한 이론들을 가상으로
                구현된 장비 및 소자를 활용하여 실제와 동일한 실험수행 지원
              </p>
            </div>
          </div>
        </div>

        
        <div class="main-title" style="margin-top: 80px; font-weight: bold; color: #193D8F;">
          <h2 style="font-size:20px;">2019년부터 매년 온라인 실험실습 공유플랫폼 고도화를 위해 노력해왔습니다. </h2>
        </div>
        <div class="timeline-content" style="">
            <div class="timeline-item timeline-1"></div>
            <!-- <div class="timeline-item timeline-2"></div> -->
        </div>
        <div style="height: 180px;"></div>

      </div>
      <app-footer class="footer" />
    </div>
  </div>
</template>

<script>
import TabHeader from "../../../components/utils/common/TabHeader.vue";
import AppFooter from "../../../components/utils/AppFooter.vue";
import $ from "jquery";

export default {
  components: { TabHeader, AppFooter },
  data() {
    return {
      selected: 0,
      titles: [
        "가상실험실 개요",
        "가상실험실 개발내용",
        "공유플랫폼 구조",
        "추진전략"
      ],
      title: ""
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
#about-page {
  font-family: "Noto Sans KR", sans-serif;
  position: relative;
  .wrapper {
    position: absolute;
    top: 220px;
    width: 100%;
        // left: 50%;
        // transform: translateX(-50%);
        text-align: center;
    height: auto;
    margin-bottom: 200px;
    // background: url("../../../assets/images/about/tutorial_bg_down.png");
    .contents {
      position: relative;
      width: 100%;
        text-align: left;
        max-width: 1200px;
      min-height: 1280px;
      margin: 0 auto;
      padding: 90px 80px;
      .main-title {
        width: 80%;
        margin: 0 auto;
        padding-bottom: 30px;
        text-align: center;
        & > h1 {
          text-align: center;
          font-size: 2.5rem;
          padding-bottom: 30px;
        }
        & > h2 {
          text-align: center;
        }
      }

      .box-content {
        margin-top: 60px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 18px;
      }
      .box-item {
        background-color: #f8f8f8;
        border: none;
        border-radius: 30px;
        padding: 28px;
        width: 306px;
        color: gray;
      }
      .box-item-title {
        width: 100%;
        text-align: center;
        margin: 20px 0;
      }
      .box-item-image {
        width: 98px;
        height: 98px;
        margin-inline: auto;
      }
      .box-item-image-1 {
        background: url("../../../assets/images/about/power-supply.png");
        background-size: contain;
      }
      .box-item-image-2 {
        background: url("../../../assets/images/about/motherboard.png");
        background-size: contain;
      }
      .box-item-image-3 {
        background: url("../../../assets/images/about/assembly.png");
        background-size: contain;
      }

      .timeline-content {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: start;
        flex-wrap: wrap;
        row-gap: 18px;
        margin-bottom: 120px;
      }
      .timeline-item {
        height: 865px;
        max-height: 865px;
      }
      .timeline-1 {
        width: 698px;
        background: url("../../../assets/images/about/timeline_1.png");
        background-size: cover;
      }
      .timeline-2 {
        width: 560px;
        background: url("../../../assets/images/about/timeline_2.png");
        background-size: cover;
      }
    }
  }
  .details {
    margin: 0 auto;
    font-size: 1.1rem;
    .introduction {
      margin-top: 50px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-weight: bold;
      text-align: center;
      & > h2 {
        width: 30%;
        margin: 0 auto;
        padding: 10px 0px;
        border-bottom: 3px solid #2156d0;
      }
      & > img {
        width: 100%;
        height: 70%;
        padding-top: 20px;
      }
    }
  }
  .footer {
    position: absolute;
    bottom: 0px;
    width: 100%;
  }
}
@media (min-width: 650px) and (max-width: 1200px) {
  #about-page .wrapper .contents .box-item {
    width: 30%;
  }

  .contents .timeline-1 {
    height: calc( (100vw - 160px) * (865 / 698)) !important;
  }
}
@media (max-width: 650px){

  .contents .timeline-1 {
    height: calc( (100vw - 160px) * (865 / 698)) !important;
  }
}

</style>
